export const APP_MAX_W = 1350;
export const APP_HEADER_H = '5.5rem';
export const FOOTER_H = 200;
export const FOOTER_MT = 100;
